import searchStates from './searchStates';

const defaultConfig = {
    loading: true,
    searchState: searchStates.INIT,
    prevSearchState: null,
    start: 1,
    limit: 36,
    facets: {},
    sort: 'price-asc'
};

export default defaultConfig;
